import type { CustomerGroup } from '~/types/customer';

export const useCustomerGroupStore = defineStore('customerGroup', () => {
    const { customer } = useCustomerStore();
    const { apiClient } = useShopwareContext(); // Access Shopware API client
    const { sessionContext } = useSessionContext();
    const customerGroups = ref<CustomerGroup[]>([]);
    const loading = ref(false);
    const error = ref<string | null>(null);

    const fetchCustomerGroups = async () => {
        if (customerGroups.value.length) return;

        loading.value = true;
        error.value = null;

        try {
            const response = await apiClient.invoke('getCustomerGroups get /customer-groups');
            customerGroups.value = response.data.customerGroups.filter(
                customerGroup => customerGroup.customFields?.allowRegistration ?? false,
            );
            return response;
        } catch (err) {
            error.value = err instanceof Error ? err.message : 'An error occurred while fetching customer groups';
        } finally {
            loading.value = false;
        }
    };

    const currentCustomerGroup = computed(() => {
        if (!customer?.groupId && !sessionContext.value?.customer?.groupId) return null;

        return customerGroups.value.find(
            customerGroup =>
                customerGroup.id === (customer?.groupId ? customer.groupId : sessionContext.value?.customer?.groupId),
        );
    });

    const allCustomerGroups = computed(() => customerGroups.value);

    const $reset = () => {
        customerGroups.value = [];
        loading.value = false;
        error.value = null;
    };

    return {
        fetchCustomerGroups,
        $reset,
        allCustomerGroups,
        currentCustomerGroup,
        loading,
        error,
    };
});
